import { getPageCluster } from '@shared/domain/PageCluster.ts';
import type { TrackingLabels } from '@shared/tracking/TrackingLabels.ts';
import { isSimilarProduct } from '@shared/types/types.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import { getSelectionRulesTracking } from '@tilelist/services/tracking/SelectionRuleTracking.browser.ts';

export function productClickLabels(
    event: Event,
    productItem: ProductItem,
    rule: string,
    entryRule: string,
): TrackingLabels | undefined {
    const { currentTarget } = event;
    if (!(currentTarget instanceof HTMLElement)) return undefined;

    const linkType = currentTarget.dataset.linkType;
    const pageCluster = getPageCluster();
    if (!linkType || !pageCluster) return undefined;

    const trackingData: TrackingLabels = productItem.product.clickTracking
        ? {
              ...productItem.product.clickTracking,
              ...getSelectionRulesTracking(rule, entryRule),
          }
        : getSelectionRulesTracking(rule, entryRule);

    if (isSimilarProduct(productItem.product)) {
        trackingData['wk.san_ListPositionSimilar'] = productItem.originPosition + 1;
    }

    trackingData.san_Interaction = `${productItem.product.productType}_product_tile`;
    trackingData['wk.san_ListPosition'] = productItem.actualListPosition;
    trackingData['wk.san_ProductType'] = productItem.product.productType;
    trackingData['wk.san_ProductClickListType'] = pageCluster;
    trackingData['wk.san_ProductLinkType'] = linkType;

    return trackingData;
}
